// reducers/noticeReducer.js
export const noticeReducer = (
  state = { notices: [], unreadCount: 0 },
  action,
) => {
  switch (action.type) {
    case "NOTICE_REQUEST":
      return { ...state, loading: true };
    case "GET_NOTICES_SUCCESS":
      return { ...state, loading: false, notices: action.payload || [] };
    case "CREATE_NOTICE_SUCCESS":
      return { ...state, loading: false, success: true };
    case "TOGGLE_NOTICE_SUCCESS":
      return {
        ...state,
        loading: false,
        notices: (state.notices || []).map((n) =>
          n.id === action.payload.id ? action.payload : n,
        ),
      };
    case "DELETE_NOTICE_SUCCESS":
      return {
        ...state,
        notices: (state.notices || []).filter((n) => n.id !== action.payload),
      };
    case "NOTICE_UNREAD_COUNT":
      return { ...state, unreadCount: action.payload };
    case "NOTICE_FAIL":
      return { ...state, loading: false, error: action.payload };
    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };
    default:
      return state;
  }
};
